import * as React from "react";

function SvgIcons8Term(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M1 6v20h4v-2H3V8h2V6zm26 0v2h2v16h-2v2h4V6zM7 11v2h18v-2zm0 4v2h15v-2zm0 4v2h18v-2z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Term);
